import React from "react";
import "./Home.css";
import Gears from "../Gears/Gears";
import Banner from "../Banner/Banner";
import Homepic from "../Homepic/Homepic";
import Cards from "../Cards/Cards";
const Home = () => {
  return (
    <div>
      <h1 className="title"> Archer Camping Gears!</h1>
      <div>
        <Banner></Banner>
        <h2 className="items-heading">Items</h2>
        <Gears></Gears>
        <Cards></Cards>
        <Homepic></Homepic>
      </div>
    </div>
  );
};

export default Home;
